var map = {
	"./cs.json": 5902,
	"./da.json": 497,
	"./de.json": 1268,
	"./en-GB.json": 562,
	"./en.json": 3747,
	"./es.json": 6539,
	"./fr-CA.json": 2542,
	"./fr.json": 8957,
	"./it.json": 4019,
	"./ja.json": 5932,
	"./ko.json": 7576,
	"./nl.json": 1721,
	"./no.json": 9012,
	"./pl.json": 5215,
	"./pt-BR.json": 5516,
	"./ru.json": 3635,
	"./sv.json": 2327,
	"./zh-Hans.json": 3510,
	"./zh-Hant.json": 6475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6988;